var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecorationIntroBlueDataAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 732,
    viewBox: "0 0 1512 732",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_30)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.09
  }, /*#__PURE__*/React.createElement("line", {
    x1: -40,
    y1: 640.644,
    x2: 1471.58,
    y2: 640.644,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -40,
    y1: 317.906,
    x2: 1471.58,
    y2: 317.906,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -40,
    y1: 479.274,
    x2: 1471.58,
    y2: 479.274,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -40,
    y1: 156.536,
    x2: 1471.58,
    y2: 156.536,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -40,
    y1: 559.959,
    x2: 1471.58,
    y2: 559.959,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -40,
    y1: 237.221,
    x2: 1471.58,
    y2: 237.221,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -40,
    y1: 398.589,
    x2: 1471.58,
    y2: 398.589,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -40,
    y1: 721.329,
    x2: 1471.58,
    y2: 721.329,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -40,
    y1: 75.8506,
    x2: 1471.58,
    y2: 75.8506,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.27525,
    y1: -33.1987,
    x2: 7.2752,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 652.756,
    y1: -33.1987,
    x2: 652.756,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 330.016,
    y1: -33.1987,
    x2: 330.016,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 975.492,
    y1: -33.1987,
    x2: 975.492,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1298.23,
    y1: -33.1987,
    x2: 1298.23,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168.645,
    y1: -33.1987,
    x2: 168.645,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 814.122,
    y1: -33.1987,
    x2: 814.122,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 491.386,
    y1: -33.1987,
    x2: 491.386,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1136.86,
    y1: -33.1987,
    x2: 1136.86,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1459.6,
    y1: -33.1987,
    x2: 1459.6,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.9625,
    y1: -33.1987,
    x2: 87.9624,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 733.439,
    y1: -33.1987,
    x2: 733.439,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.698,
    y1: -33.1987,
    x2: 410.698,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1056.18,
    y1: -33.1987,
    x2: 1056.18,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1378.92,
    y1: -33.1987,
    x2: 1378.91,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.333,
    y1: -33.1987,
    x2: 249.333,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 894.809,
    y1: -33.1987,
    x2: 894.809,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 572.069,
    y1: -33.1987,
    x2: 572.069,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1217.54,
    y1: -33.1987,
    x2: 1217.54,
    y2: 1134.21,
    stroke: "white",
    strokeOpacity: 0.38,
    strokeWidth: 1.2607
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip1_31_30)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 336.248,
    y: 634.381,
    width: 80.2262,
    height: 79.0801,
    fill: "#19224A",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496.65,
    y: 704.06,
    width: 80.2262,
    height: 79.0801,
    fill: "#19224A",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.248,
    y: 220.381,
    width: 80.2262,
    height: 79.0801,
    fill: "#19224A",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.277,
    y: 462.286,
    width: 80.2262,
    height: 79.0801,
    fill: "#19224A",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1061.67,
    y: 462.286,
    width: 80.2262,
    height: 79.0801,
    fill: "#19224A",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.277,
    y: 704.06,
    width: 80.2262,
    height: 79.0801,
    fill: "#19224A",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.474,
    y: 714.068,
    width: 80.2262,
    height: 80.2262,
    fill: "#19224A",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.3708,
    y: 633.381,
    width: 80.2262,
    height: 79.5062,
    fill: "#19224A",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.3708,
    y: 713.639,
    width: 80.2262,
    height: 80.0285,
    fill: "#19224A",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.353,
    y: 220.335,
    width: 81.3723,
    height: 82.5184,
    fill: "#19224A",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.9805,
    y: 140.109,
    width: 81.3723,
    height: 80.2262,
    fill: "#19224A",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.7543,
    y: 141.255,
    width: 81.3723,
    height: 80.2262,
    fill: "#19224A",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.9805,
    y: 220.335,
    width: 81.3723,
    height: 82.5184,
    fill: "#19224A",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.25,
    y: 507.379,
    width: 80.2262,
    height: 81.3723,
    fill: "#19224A",
    fillOpacity: 0.4
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_30"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 732,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_31_30"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1250,
    height: 657,
    fill: "white",
    transform: "translate(13 209)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecorationIntroBlueDataAnalytics);
export default __webpack_public_path__ + "static/media/decorationIntroBlueDataAnalytics.8c4be432cf113e2a6dbc541c676a27e3.svg";
export { ForwardRef as ReactComponent };